import { object, string, date, ref } from "yup";

export const getValidation = () => {
  const validationSchema = object().shape(
    {
      name: string()
        .required()
        .default(""),
      startTime: date()
        .nullable()
        .when("endTime", (value, schema) => {
          if (value) {
            return schema
              .max(ref("endTime"), "End Time can’t be prior Start Time.")
              .required();
          }
        }),
      endTime: date()
        .nullable()
        .when("startTime", (value, schema) => {
          if (value) {
            return schema
              .min(ref("startTime"), "End Time can’t be prior Start Time.")
              .required();
          }
        })
    },
    [["startTime", "endTime"]]
  );

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
